module.exports = __webpack_public_path__ + "img/electric-mining-drill-S-patch.9f691af5.png";